<button 
    class="sec-button"
    (click)="emitClick()" 
    [disabled]="disabled"
>
    {{buttonText}}
</button>
